import { Component, Input, ElementRef, OnInit } from '@angular/core';
import { single, multi, unattended, unattended1 } from '../data';

@Component({
  selector: 'unattended-chart',
  templateUrl: './unattended-chart.component.html',
  styleUrls: [ './unattended-chart.component.css' ]
})


export class UnattendedChartComponent implements OnInit { 
    @Input() unattended;    
    single: any[];
    multi: any[];
    //unattended: any[];
    view: any[]; //;[700, 300];
  
    // options
    showXAxis = true;
    showYAxis = true;
    gradient = false;
    showLegend = true;
    showXAxisLabel = true;
    //xAxisLabel = 'Country';
    showYAxisLabel = true;
    //yAxisLabel = 'Population';

    xAxisLabel: string;
    yAxisLabel: string;
  
    colorScheme = 'nightLights';//'vivid';
    //colorScheme = {
    //  domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    //};
  
    // line, area
    autoScale = true;

    constructor(protected chartElement: ElementRef) {
      Object.assign(this, {single, multi, unattended})   
    }
    
    onSelect(event) {
      console.log(event);
    }

    getContainerDims(): any {
      let width;
      let height;
      const hostElem = this.chartElement.nativeElement;
  
      if (hostElem.parentNode !== null) {
        // Get the container dimensions
        const dims = hostElem.parentNode.getBoundingClientRect();
        width = dims.width;
        height = dims.height;
      }
  
      if (width && height) {
        return { width, height };
      }
  
      return null;
    }
  

    formatDate(datestring : string) {

        var date = new Date(datestring);
       
        var monthIndex = date.getMonth() + 1;
        var dayNumber = date.getDate();
        var dayNumberString = null;
        if(dayNumber < 10)
        {
            dayNumberString = `0${dayNumber}`;
        }
        else { dayNumberString = dayNumber; }
        var year = date.getFullYear();
        return `${monthIndex}/${dayNumberString || dayNumber}`;
        //return dayNames[dayIndex];
        //return date.toLocaleString();
      }
      
    ngOnInit() {    
    } 
  
}
